import { pluginId } from '../pluginId';

export const RESOLVE_LOCALES = `${pluginId}/locales/resolve-locales`;
export const ADD_LOCALE = `${pluginId}/locales/add`;
export const DELETE_LOCALE = `${pluginId}/locales/delete`;
export const UPDATE_LOCALE = `${pluginId}/locales/update`;
